// Create and show the offcanvas
const offcanvasEl = document.getElementById('productsOffcanvas');
const bsOffcanvas = new bootstrap.Offcanvas(offcanvasEl);
//bsOffcanvas.show();

function refreshFlickityIn(container) {
  container.querySelectorAll('.js-flickity').forEach(function (el) {
    const flkty = Flickity.data(el);
    if (flkty) {
      flkty.resize();
      flkty.reposition();
      // optional: force it to stay on current slide
      // flkty.select(flkty.selectedIndex);
    }
  });
}

function initProductsOffcanvas(){
  // Close if clicking outside of the offcanvas area
  $(document).on('click', function (e) {
    // only act if the main offcanvas is open
    if (offcanvasEl.classList.contains('show')) {

      // skip clicks inside the offcanvas or its toggle button
      const clickedInsideOffcanvas = offcanvasEl.contains(e.target);
      const clickedToggle = e.target.closest('[data-bs-toggle="offcanvas"]');

      // NEW: skip clicks inside the custom drawer
      const clickedInsideDesignDrawer = document.getElementById('design-detail-drawer')?.contains(e.target);

      // Only close if click is *not* in any of those
      if (!clickedInsideOffcanvas && !clickedToggle && !clickedInsideDesignDrawer) {
        bsOffcanvas.hide();
      }
    }
  });

  // 1) when offcanvas is shown
  offcanvasEl.addEventListener('shown.bs.offcanvas', function () {
    refreshFlickityIn(offcanvasEl);
  });

  // 2) when a Bootstrap tab is shown (anywhere on the page)
  // this covers the "client switches tabs and carousel is blank" report
  document.addEventListener('shown.bs.tab', function (e) {
    // if your flickity is inside the offcanvas, limit the refresh to it
    refreshFlickityIn(offcanvasEl);
  });

  designPickerRender();
}

function designPickerRender(){
  $('.card-design').each(function() {
    const $card = $(this);
    const qty = parseInt($card.data('quantity')) || 0;

    // update the input inside
    $card.find('.quantity-input').val(qty);

    // optional: add/remove a visual state
    if (qty > 0) {
      $card.addClass('is-selected');
      $card.data("selected", true).attr("data-selected", "true");
      $($card).find(".input-group").show();
      $($card).find('.badge_container').css('visibility', 'hidden');
    } else {
      $card.removeClass('is-selected');
      $($card).find(".input-group").hide();
      $($card).find('.badge_container').css('visibility', 'visible');
    }
  });
}

$(document).ready(function() {
  // Define globally, run once on page load
  initProductsOffcanvas();

  window.addEventListener('__bundle_changed', function(e){
    designPickerRender();
  }, false);

  window.addEventListener('__design_selected', function(e){
    //e.detail.id;
    let id = e.detail.id;
    let card_obj = $(".card-design[data-id='"+id+"']");
    if( card_obj ){
      $(card_obj).data("quantity", ($(card_obj).data("quantity") || 0) + 1);
      window.dispatchEvent( new CustomEvent("__bundle_changed", {detail: null}) );
      closeDesignDrawer();
    }
    
  }, false);
  window.addEventListener('__design_remove', function(e){
    //e.detail.id;
    let id = e.detail;
    let card_obj = $(".card-design[data-id='"+id+"']");
    if( card_obj ){
      $(card_obj).data("quantity", ($(card_obj).data("quantity") || 0) - 1);
      window.dispatchEvent( new CustomEvent("__bundle_changed", {detail: null}) );
      closeDesignDrawer();
    }
    
  }, false);


  $('.btn-minus, .btn-plus').on('click', function(e) {
    e.stopPropagation(); // prevent triggering designPick
    const $card = $(this).closest('.card-design');
    const $input = $card.find('.quantity-input');
    let qty = parseInt($input.val()) || 0;
if( __bundle==="basic" ){
          free_slot = {base: 1, free: 1};
        }
        else if( __bundle==="standard" ){
          free_slot = {base: 2, free: 2};
        }
        else if( __bundle==="premium" ){
          free_slot = {base: 3, free: 3};
        }
        const totalSlots = free_slot.base + free_slot.free;
    let card_obj = $card;
    const variantId = $(card_obj).data('id');
    if ($(this).hasClass('btn-plus')) {
      qty++;
    designs.push({
             id: $(card_obj).data('id'),
            image: $(card_obj).data('image'),
            name: $(card_obj).data('name'),
            price: $(card_obj).data('price'),
            extra: designs.length > (totalSlots - 1),
            indexp: designs.length,
          });
          console.log("designs", designs);
    } else {
      qty = Math.max(0, qty - 1);
      for (let i = designs.length - 1; i >= 0; i--) {
            if (designs[i].id === variantId) {
                designs.splice(i, 1);
                break; 
            }
        }
    }

    $input.val(qty);
    $card.data('quantity', qty);
    
          console.log("design",designs);

    window.dispatchEvent( new CustomEvent("__bundle_changed", {detail: null}) );
  });

  $('.js-flickity').each(function() {
    const $carousel = $(this);
    const flkty = $carousel.data('flickity'); // Flickity instance

    // If not yet initialized (safety check)
    if (!flkty) return;

    // Hover to go to 2nd slide
    $carousel.on('mouseenter', function() {
      flkty.select(1);
    });

    // Leave to go back to 1st slide
    $carousel.on('mouseleave', function() {
      flkty.select(0);
    });
  });
});


function designsPopupOpen(){
    bsOffcanvas.show();
}